import React, { useState, useRef, useEffect } from 'react';
import styled from '@emotion/styled';
import { mqMin } from 'utils/responsive';

const Container = styled.section`
    padding: 45px 0 52px 0;
    ${mqMin('NARROW')} {
        padding: 78px 0 70px 0;
    }
`;

const H2 = styled.h2`
    text-align: center;
    font-size: 1.75rem;
    margin-bottom: 28px;
    ${mqMin('NARROW')} {
        text-align: center;
        font-size: 1.75rem;
        margin-bottom: 28px;
    }
`;

const QAContainer = styled.section`
    width: 88.37209302325581%;
    border-top: solid 2px var(--dark-blue);
    border-bottom: solid 2px var(--dark-blue);
    margin: 0 auto;

    ${mqMin('NARROW')} {
        padding: 45px 0 52px 0;
    }
`;

const Item = styled.section`
    width: 100%;
    border-bottom: solid 1px #dadada;
`;

const QButton = styled.div`
    width: 100%;
    position: relative;
    background-color: #fff;
    color: var(--dark-blue);
    padding: 0;
    cursor: pointer;
`;

const QTextContainer = styled.div`
    display: flex;
    align-items: center;
    h3 {
        width: calc(100% - 24px);
        padding: 20px;
        text-align: left;
        font-size: 1.125rem;
        line-height: 1.7em;
        letter-spacing: 0.1em;
        ${mqMin('NARROW')} {
            font-size: 1rem;
        }
    }
`;

const QMark = styled.div<{ isOpen: boolean }>`
    position: relative;
    display: block;
    width: 20px;
    height: 20px;
    span:nth-of-type(1) {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        display: block;
        width: 100%;
        height: 2px;
        background-color: var(--dark-blue);
    }
    span:nth-of-type(2) {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        display: block;
        width: 2px;
        height: 100%;
        background-color: var(--dark-blue);
        transition: transform 0.2s;
        transform: ${({ isOpen }) => (isOpen ? 'rotate(90deg)' : 'rotate(0deg)')};
    }
`;

const AItem = styled.div<{ isOpen: boolean }>`
    width: 100%;
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
    max-height: ${({ isOpen }) => (isOpen ? '500px' : '0')}; /* 仮の最大値 */
`;

const AItemText = styled.div`
    padding: 0 20px 20px 20px;
    text-align: left;
    line-height: 1.7em;
    letter-spacing: 0.1em;
    ${mqMin('NARROW')} {
        font-size: 0.875rem;
    }
`;

const OrangeText = styled.p`
    color: var(--orange);
`;

const faqData = [
    {
        question: 'どのタイミングで料金が発生しますか？',
        answer: (
            <>
                <OrangeText>
                    売却希望企業が、オファーを承諾し、情報開示・チャットが開設されたタイミングで、リード料（税抜5万円）が発生します。
                </OrangeText>
                <p>
                    それまでは、何件オファーを送っても費用はかかりません。 <br />
                    ※ただし、プレミアムオファーを送信する場合にはオファー1件の送信にあたり2万円（税抜）がかかり、こちらはオファー承諾の要否にかかわらず返金対象外となります。
                    <br />
                    <br />
                    通常のオファー送信のみのご利用であれば、完全成果課金型の安心設計です。
                </p>
            </>
        ),
    },
    {
        question: '匿名の投稿だけで、ちゃんと案件の見極めができますか？',
        answer: (
            <>
                <OrangeText>
                    匿名とはいえ、業種・地域・売上レンジ・従業員規模・相談内容など、オファー判断に必要な情報を掲載いたします。
                </OrangeText>
                <p>「興味を持てるか」を判断できる情報を事前にご確認いただけます。</p>
            </>
        ),
    },
    {
        question: 'オファーはどのように送るのですか？作成が面倒では？',
        answer: (
            <>
                <OrangeText>オファーは、専用の入力フォームを利用して3分程度で送信可能です。</OrangeText>
                <p>
                    自社の強みや支援実績などを簡単に記載できるよう設計されています。
                    <br />
                    複数の担当者が使えるアカウント機能もあります。
                </p>
            </>
        ),
    },
    {
        question: '成約に至らなかった場合、リード料は返金されますか？',
        answer: (
            <OrangeText>
                リード料は「売却検討企業との接点提供」に対する成果課金ですので、成約有無にかかわらず返金対象外となります。
            </OrangeText>
        ),
    },
    {
        question: '月額費用や登録料はかかりますか？',
        answer: (
            <>
                <OrangeText>かかりません。</OrangeText>
                <p>
                    初期費用・月額利用料は完全無料です。
                    <br />
                    費用は、リードが成立（情報開示＋チャット開設）した場合またはプレミアムオファーを利用した場合のみ発生します。
                </p>
            </>
        ),
    },
    {
        question: '請求の流れはどうなっていますか？',
        answer: (
            <>
                <OrangeText>リード料金の請求は毎月20日締め・月末請求で、請求書払いに対応しています。</OrangeText>
                <p>前月21日から当月20日までに承諾された件数に応じて請求が発生します。</p>
            </>
        ),
    },
    {
        question: '案件の地域や業種に偏りはありますか？',
        answer: (
            <OrangeText>
                現在、幅広い地域・業種の相談案件が集まっていますが、仲介会社様のご希望に応じて業種やエリアをフィルターして検索することが可能です。
            </OrangeText>
        ),
    },
    {
        question: '導入までにどれくらい時間がかかりますか？',
        answer: (
            <>
                <OrangeText>アカウント作成申し込み後、所定の審査がございます。</OrangeText>
                <p>最短でご契約日から3営業日〜5営業日後にはアカウント発行が可能です。</p>
            </>
        ),
    },
];

export const QA: React.FC = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const answerRefs = useRef<(HTMLDivElement | null)[]>([]);

    const toggleFAQ = (index: number) => {
        setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    useEffect(() => {
        answerRefs.current.forEach((ref, index) => {
            if (ref) {
                if (openIndex === index) {
                    ref.style.maxHeight = ref.scrollHeight + 'px';
                } else {
                    ref.style.maxHeight = '0';
                }
            }
        });
    }, [openIndex]);

    return (
        <Container id="qa">
            <H2 className="fadein fadein_y">よくあるご質問</H2>
            <QAContainer className="fadein fadein_y">
                {faqData.map((faq, index) => (
                    <Item key={index}>
                        <QButton className="topFaq_item_q" onClick={() => toggleFAQ(index)}>
                            <QTextContainer className="topFaq_item_q_text">
                                <h3>{faq.question}</h3>
                                <QMark isOpen={openIndex === index}>
                                    <span className="topFaq_item_q_mark_line01"></span>
                                    <span className="topFaq_item_q_mark_line02"></span>
                                </QMark>
                            </QTextContainer>
                        </QButton>
                        <AItem ref={(el) => (answerRefs.current[index] = el)} isOpen={openIndex === index}>
                            <AItemText>{faq.answer}</AItemText>
                        </AItem>
                    </Item>
                ))}
            </QAContainer>
        </Container>
    );
};
